export const clickableLinkSx = {
  userSelect: 'none',
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
  textDecorationColor: 'whiteAlpha.500',
  _hover: {
    textDecoration: 'none',
  },
}
